import FoundationIndex from './foundation';

export default class FoundationIndexDesktop extends FoundationIndex {
    constructor(...args) {
        super(...args);
    }

    /**
     * init() {}
     * bind() {}
     * unbind() {}
     * resize(width, height) {}
     * _destroy() {}
     */
}



// WEBPACK FOOTER //
// src/js/pages/foundation/foundation.desktop.js